<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="config">
  <div ngxSlickItem *ngFor="let slide of slides" class="slide">
    <img [src]="slide.img" alt="">
  </div>
</ngx-slick-carousel>